import { useFontSizePreference } from './font-size';

export function FontSizeControl({ variant = 'select' }: { variant?: 'select' | 'buttons' }) {
  const [fontSize, setFontSize] = useFontSizePreference();
  if (variant === 'buttons') return <div className="font-size-control font-size-control--buttons" role="group" aria-label="字体大小">
    <span>字体</span>
    {(['large', 'medium', 'small'] as const).map(value => {
      const label = value === 'large' ? '大' : value === 'medium' ? '中' : '小';
      return <button key={value} type="button" aria-label={`${label}号字体`} aria-pressed={fontSize === value} onClick={() => setFontSize(value)}>{label}</button>;
    })}
  </div>;
  return (
    <label className="font-size-control">
      <span>字体</span>
      <select
        aria-label="字体大小"
        value={fontSize}
        onChange={(event) => {
          const value = event.target.value;
          if (value === 'small' || value === 'medium' || value === 'large') setFontSize(value);
        }}
      >
        <option value="small">小号</option>
        <option value="medium">中号</option>
        <option value="large">大号</option>
      </select>
    </label>
  );
}
